import React, { useState, useEffect } from "react";

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Show button after scrolling 300px
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    isVisible && (
      <button
        onClick={handleScrollTop}
        className="back-to-top result-placeholder"
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          background: "white",
          border: "none",
          borderRadius: "50%",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          padding: "10px",
          cursor: "pointer",
          zIndex: 9999,
        }}
        aria-label="Back to Top"
      >
        <div className="back-to-top-wrap active-progress">
          <svg viewBox="-1 -1 102 102" width="30" height="30">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        {/* <i className="ri-arrow-up-line" style={{ fontSize: "20px" }} /> */}

        </div>
      </button>
    )
  );
}
